// Generated by BUCKLESCRIPT VERSION 4.0.14, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");

var Caml_option = require("bs-platform/lib/js/caml_option.js");

var Monad$Rationale = require("./Monad.js");

var Function$Rationale = require("./Function.js");

var Applicative$Rationale = require("./Applicative.js");

var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");

function some(a) {
  return Caml_option.some(a);
}

function none(param) {
  return undefined;
}

function isNone(o) {
  return o === undefined;
}

function isSome(o) {
  return o !== undefined;
}

function $$default(d, o) {
  if (o !== undefined) {
    return Caml_option.valFromOption(o);
  } else {
    return d;
  }
}

function ofResult(r) {
  if (r.tag) {
    return undefined;
  } else {
    return Caml_option.some(r[0]);
  }
}

function toExn(err, o) {
  if (o !== undefined) {
    return Caml_option.valFromOption(o);
  } else {
    throw [Caml_builtin_exceptions.failure, err];
  }
}

function firstSome(a, b) {
  if (a !== undefined) {
    return a;
  } else {
    return b;
  }
}

function tryWith(f) {
  try {
    return Caml_option.some(Curry._1(f,
    /* () */
    0));
  } catch (exn) {
    return undefined;
  }
}

function bind(o, f) {
  if (o !== undefined) {
    return Curry._1(f, Caml_option.valFromOption(o));
  }
}

var include = Monad$Rationale.MakeBasic(
/* module */
[
/* bind */
bind,
/* return */
some,
/* fmap : DefineWithBind */
254677598]);
var bind$1 = include[0];
var $$return = include[1];
var $great$great$eq = include[3];
var $less$$great = include[4];

function apply(o, a) {
  if (o !== undefined) {
    var f = o;
    return Curry._2(bind$1, a, function (b) {
      return Curry._1($$return, Curry._1(f, b));
    });
  }
}

var include$1 = Applicative$Rationale.MakeBasic(
/* module */
[
/* apply */
apply,
/* pure */
some]);
var Infix_002 =
/* <*> */
include$1[2];
var Infix =
/* module */
[
/* >>= */
$great$great$eq,
/* <$> */
$less$$great, Infix_002,
/* |? */
firstSome];

function map(f, o) {
  return Function$Rationale.flip($less$$great, f, o);
}

function iter(f, o) {
  if (o !== undefined) {
    return Curry._1(f, Caml_option.valFromOption(o));
  } else {
    return (
      /* () */
      0
    );
  }
}

function fold(f, acc, o) {
  if (o !== undefined) {
    return Curry._2(f, acc, Caml_option.valFromOption(o));
  } else {
    return acc;
  }
}

function filter(p, o) {
  if (o !== undefined && Curry._1(p, Caml_option.valFromOption(o))) {
    return o;
  }
}

function exists(p, o) {
  if (o !== undefined) {
    return Curry._1(p, Caml_option.valFromOption(o));
  } else {
    return false;
  }
}

function flatten(o) {
  if (o !== undefined) {
    return Caml_option.valFromOption(o);
  }
}

function flatMap(f, o) {
  return Function$Rationale.flip($great$great$eq, f, o);
}

function compare(f, o1, o2) {
  if (o1 !== undefined) {
    if (o2 !== undefined) {
      return Curry._2(f, Caml_option.valFromOption(o1), Caml_option.valFromOption(o2));
    } else {
      return 1;
    }
  } else if (o2 !== undefined) {
    return -1;
  } else {
    return 0;
  }
}

function equal(f, o1, o2) {
  if (o1 !== undefined) {
    if (o2 !== undefined) {
      return Curry._2(f, Caml_option.valFromOption(o1), Caml_option.valFromOption(o2));
    } else {
      return false;
    }
  } else {
    return o2 === undefined;
  }
}

function toList(o) {
  if (o !== undefined) {
    return (
      /* :: */
      [Caml_option.valFromOption(o),
      /* [] */
      0]
    );
  } else {
    return (
      /* [] */
      0
    );
  }
}

function ofList(l) {
  if (l) {
    return Caml_option.some(l[0]);
  }
}

var fmap = include[2];
var apply$1 = include$1[0];
var pure = include$1[1];
exports.some = some;
exports.none = none;
exports.isNone = isNone;
exports.isSome = isSome;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
exports.ofResult = ofResult;
exports.toExn = toExn;
exports.firstSome = firstSome;
exports.tryWith = tryWith;
exports.bind = bind$1;
exports.$great$great$eq = $great$great$eq;
exports.$$return = $$return;
exports.fmap = fmap;
exports.$less$$great = $less$$great;
exports.apply = apply$1;
exports.pure = pure;
exports.Infix = Infix;
exports.map = map;
exports.iter = iter;
exports.fold = fold;
exports.filter = filter;
exports.exists = exists;
exports.flatten = flatten;
exports.flatMap = flatMap;
exports.compare = compare;
exports.equal = equal;
exports.toList = toList;
exports.ofList = ofList;
/* include Not a pure module */